export default () => {
    const faqs = document.querySelectorAll('.js-faq-btn');
    faqs.forEach(function (item) {
        item.addEventListener('click', (e) => {
            e.target.closest('.js-faq').classList.toggle('faq--active');
        });
    });
}
